import React, { useEffect, useRef } from 'react'
import { Link } from '@mui/material'

export default function ObfuscatedEmail({ color, sx = {} }) {
    const emailRef = useRef(null)

    useEffect(() => {
        if (emailRef.current) {
            // Obfuscated using ASCII character codes
            const u = String.fromCharCode(105, 110, 102, 111) // 'info'
            const d = String.fromCharCode(
                101,
                108,
                101,
                99,
                116,
                114,
                111,
                98,
                114,
                97,
                105,
                100,
                46,
                99,
                111,
                109,
            ) // 'electrobraid.com'

            const email = u + '@' + d

            emailRef.current.innerHTML = email
            emailRef.current.href = 'mailto:' + email
        }
    }, [])

    return (
        <Link
            ref={emailRef}
            sx={{
                color: color || 'inherit', // Use provided color or inherit from parent
                ...sx,
            }}
            underline="none"
            aria-label="Contact us via email"
        >
            {/* Fallback for no JavaScript */}
            <noscript>info [at] electrobraid [dot] com</noscript>
        </Link>
    )
}
